var exports = {
  "K": "xcc377c0b--8daba8--icon",
};

module.exports = exports;
